<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
    <p style="color: white">Please Wait...While Fetching Data</p>
</ngx-spinner>

<div class="header_second">
    <div class="Dashboard_head">
        <!-- <div class="page-heading">
            <span class="page-title">Reports</span>

            <mat-radio-group class="report-type-group" [(ngModel)]="report_type"
                (ngModelChange)="Get_Report(report_type)">
                <mat-radio-button class="report-type-option" [matBadge]="total_reg" matBadgeOverlap="false"
                    value="all">Register</mat-radio-button>
                <mat-radio-button class="report-type-option" [matBadge]="total_checkin" matBadgeOverlap="false"
                    value="checkin">Check In</mat-radio-button>
                <mat-radio-button class="report-type-option" [matBadge]="total_checkout" matBadgeOverlap="false"
                    value="checkout">Check Out</mat-radio-button>
                <mat-radio-button class="report-type-option" [matBadge]="total_notvisited" matBadgeOverlap="false"
                    value="notvisited">Not Visited</mat-radio-button>
            </mat-radio-group>
        </div> -->

        <div class="page-heading">
            <button mat-icon-button color="primary" (click)="reg()">
                <mat-icon>arrow_back</mat-icon>
                <!-- Back -->
            </button>
            <span class="page-title">Reports</span>

        </div>
        <mat-button-toggle-group [(ngModel)]="report_type" (change)="Get_Report(report_type)" class="report-toggle"
            aria-label="Report Type">

            <mat-button-toggle value="all">
                Register <span class="badge">{{ total_reg }}</span>
            </mat-button-toggle>

            <mat-button-toggle value="checkin">
                Check In <span class="badge">{{ total_checkin }}</span>
            </mat-button-toggle>

            <mat-button-toggle value="checkout">
                Check Out <span class="badge">{{ total_checkout }}</span>
            </mat-button-toggle>

            <mat-button-toggle value="notvisited">
                Not Visited <span class="badge">{{ total_notvisited }}</span>
            </mat-button-toggle>

        </mat-button-toggle-group>

        <div class="header-actions">


            <button color="accent" mat-stroked-button (click)="exportTable(report_type)">
                <mat-icon>download</mat-icon>
                Export
            </button>

            <button mat-stroked-button color="primary" (click)="transactions()">
                <mat-icon>list</mat-icon>
                Transactions
            </button>
        </div>
    </div>
</div>

<div class="mat-elevation-z8 report-card">
    <div class="filter">
        <mat-form-field appearance="outline" class="filter-search" subscriptSizing="dynamic">
            <mat-label>Search</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input>
        </mat-form-field>
        <!-- <div>
            <button class="me-3" mat-raised-button color="primary" (click)="toggleEventAdvancedSearch()">
                <mat-icon>filter_list</mat-icon> Advance Search
            </button>
        </div> -->
        <form class="filter-form">
            <!-- <div class="search-column" *ngIf="report_type =='all'">

                <mat-form-field appearance="outline" class="me-3" style="width: 250px;">
                    <mat-label>Enter a date range</mat-label>
                    <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                        <input matStartDate formControlName="start" placeholder="Start date">
                        <input matEndDate formControlName="end" placeholder="End date">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>

                <p>Selected range: {{range.value | json}}</p>



                <mat-form-field appearance="outline" class="me-3" style="width: 175px;">
                    <mat-label>Date</mat-label>
                    <input matInput [formControl]="searchCriteria.reg_date" [matDatepicker]="picker"
                        (dateChange)="onEventSearchButtonClick()">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>

                <button mat-flat-button color="primary" (click)="
                    onClearEventFilters();onEventSearchButtonClick();">CLEAR</button>

            </div> -->
            <!-- <div class="search-column" *ngIf="report_type !='all'">
                <mat-form-field appearance="outline" class="me-3" style="width: 175px;" *ngIf="report_type !='all'">
                    <mat-label>Scanning Point</mat-label>
                    <mat-select [formControl]="searchCriteria.point">
                        <mat-option *ngFor="let data of filteredPointsData"
                            value="{{data.point}}">{{data.point}}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="me-3" style="width: 175px;">
                    <mat-label>Date</mat-label>
                    <input matInput [formControl]="searchCriteria.date" [matDatepicker]="picker"
                        (dateChange)="onEventSearchButtonClick()">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>

                <button mat-flat-button color="primary"
                    (click)="onClearEventFilters();onEventSearchButtonClick();">CLEAR</button>

            </div> -->

            <div class="search-column">
                <mat-form-field appearance="outline" class="filter-field point-field"
                    *ngIf="report_type !='all' && report_type !='notvisited'" subscriptSizing="dynamic">
                    <mat-label>Scanning Point</mat-label>
                    <mat-select [formControl]="searchCriteria.point" (selectionChange)="onEventSearchButtonClick()">
                        <mat-option *ngFor="let data of filteredPointsData"
                            value="{{data.point}}">{{data.point}}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field point-field" subscriptSizing="dynamic">
                    <mat-label>Ticket Category</mat-label>
                    <mat-select [formControl]="searchCriteria.tic_category"
                        (selectionChange)="onEventSearchButtonClick()">
                        <mat-option *ngFor="let data of getUniqueTicket" [value]="data">{{data.category}}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="filter-field date-range-field" subscriptSizing="dynamic">
                    <mat-label>Enter a date range</mat-label>
                    <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                        <input matStartDate formControlName="start" placeholder="Start date">
                        <input matEndDate formControlName="end" placeholder="End date">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>

                <button type="button" mat-flat-button color="primary" class="clear-button"
                    (click)="onClearEventFilters();onEventSearchButtonClick();">CLEAR</button>

            </div>

            <!-- <div class="action" align="end">
                <button class="me-2" mat-flat-button color="warn"
                    (click)="toggleEventAdvancedSearch()"><mat-icon>close</mat-icon>Close</button>
                <button class="me-2" mat-flat-button color="accent" (click)="onClearEventFilters()"><mat-icon>
                        clear_all</mat-icon>Clear
                    Filters</button>
                <button mat-flat-button color="primary"
                    (click)="onEventSearchButtonClick()"><mat-icon>search</mat-icon>Search</button>
            </div> -->

        </form>
    </div>

    <mat-divider></mat-divider>

    <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort recycleRows class="report-table">

            <!-- Position Column -->
            <ng-container matColumnDef="mem_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> No. </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'No.'"> {{element.mem_id}} </td>
            </ng-container>

            <ng-container matColumnDef="point">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Point </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Point'"> {{element.point}} </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Name'"> {{element.name}} </td>
            </ng-container>

            <ng-container matColumnDef="image">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Image </th>
                <td mat-cell *matCellDef="let element" class="image-cell" [attr.data-label]="'Image'">
                    <a [href]="element.image" target="_blank" class="report-image-link">
                        <img src="{{element.image}}" class="report-image"
                            onerror="this.src=`https://aieventzo.com/upload/default.png`">
                    </a>
                </td>
            </ng-container>

            <!-- <ng-container matColumnDef="id_proof">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID Proof </th>
                <td mat-cell *matCellDef="let element">
                    <img src="{{element.id_proof}}" style="width: 50px;height: 50px;"
                        onerror="this.src=`https://aieventzo.com/upload/default.png`">
                </td>
            </ng-container> -->

            <!-- Weight Column -->
            <ng-container matColumnDef="mobile">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Mobile </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Mobile'"> {{element.mobile}} </td>
            </ng-container>

            <ng-container matColumnDef="tic_category">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Ticket Category </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Ticket Category'"> {{element.category}} </td>
            </ng-container>

            <!-- <ng-container matColumnDef="whatsapp_status" stickyEnd>
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID-Card Sent </th>
                <td mat-cell *matCellDef="let element"> {{element.whatsapp_status}} </td>
            </ng-container> -->

            <!-- Symbol Column -->
            <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Address </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Address'"> {{element.address}} </td>
            </ng-container>

            <ng-container matColumnDef="city">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> City </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'City'"> {{element.city}} </td>
            </ng-container>

            <ng-container matColumnDef="state">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> State </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'State'"> {{element.state}} </td>
            </ng-container>

            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Date'"> {{element.date}} </td>
            </ng-container>

            <ng-container matColumnDef="time">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Time </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Time'"> {{element.time}} </td>
            </ng-container>

            <ng-container matColumnDef="field1">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> field 1 </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Field 1'"> {{element.field1}} </td>
            </ng-container>

            <ng-container matColumnDef="field2">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> field 2 </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Field 2'"> {{element.field2}} </td>
            </ng-container>

            <ng-container matColumnDef="field3">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> field 3 </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Field 3'"> {{element.field3}} </td>
            </ng-container>

            <ng-container matColumnDef="field4">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> field 4 </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Field 4'"> {{element.field4}} </td>
            </ng-container>

            <ng-container matColumnDef="field5">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> field 5 </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Field 5'"> {{element.field5}} </td>
            </ng-container>

            <ng-container matColumnDef="field6">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> field 6 </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Field 6'"> {{element.field6}} </td>
            </ng-container>

            <ng-container matColumnDef="field7">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> field 7 </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Field 7'"> {{element.field7}} </td>
            </ng-container>

            <ng-container matColumnDef="field8">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> field 8 </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Field 8'"> {{element.field8}} </td>
            </ng-container>

            <ng-container matColumnDef="field9">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> field 9 </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Field 9'"> {{element.field9}} </td>
            </ng-container>

            <ng-container matColumnDef="barcode">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> barcode </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Barcode'"> {{element.barcode}} </td>
            </ng-container>

            <ng-container matColumnDef="payment_status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Payment Status </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Payment Status'"> {{element.payment_status}}
                </td>
            </ng-container>

            <ng-container matColumnDef="transaction_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Transaction ID </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Transaction ID'"> {{element.transaction_id}}
                </td>
            </ng-container>

            <ng-container matColumnDef="allowed_person">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Allowed Person </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Allowed Person'"> {{element.allowed_person}}
                </td>
            </ng-container>

            <ng-container matColumnDef="created_by">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> created by </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Created By'"> {{element.created_by}} </td>
            </ng-container>

            <ng-container matColumnDef="action" stickyEnd>
                <th mat-header-cell *matHeaderCellDef> Action </th>
                <td mat-cell *matCellDef="let element" [attr.data-label]="'Action'">
                    <div class="action-cell">
                        <button mat-raised-button color="warn" matTooltip="Delete" class="delete-button"
                            (click)="DeleteReport(element.reg_id,element.id,report_type)" *ngIf="Enable_Delete">
                            <mat-icon class="m-0">delete</mat-icon>
                            <span class="delete-button-label">Delete</span>
                        </button>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <mat-paginator class="report-paginator" [pageSizeOptions]="[100, 250, 500]" showFirstLastButtons
        aria-label="Select page of periodic elements">
    </mat-paginator>
</div>